import { findIndex } from "lodash";
import {
  TOGGLE_MODAL_OPEN,
  TOGGLE_POWER,
  SET_TIMER,
  SET_VOLTAGE,
  SET_CURRENT,
  ON_START,
  ON_STOP,
  ANIMATION_PLAYBACK_COMPLETE,
} from "../../Redux.constants";

const templateState = {
  modalOpen: false,
  power: false,
  pluggedIn: false,
  settings: {
    voltage: 100,
    current: 0.7,
    timer: new Date(0, 0, 0),
    hours: 0,
    minutes: 0,
    seconds: 0,
  },
  running: false,
  completed: false,
  cables: {
    anode: null,
    cathode: null,
  },
  anodeConnected: false,
  cathodeConnected: false,
  // power: false,
  // active: false,
  // voltage: 0,
  // current: 0.7,
  // watts: 0,
  // timer: 1800,
  // increment: 10,
  // voltageIncrement: 10,
  // currentIncrement: 0.1,
  // timeIncrement: 30,
  // minTime: 0,
  // maxTime: 6000,
  // minVoltage: 0,
  // maxVoltage: 300,
  // minWatt: 0,
  // maxWatt: 300,
  // minCurrent: 0,
  // maxCurrent: 10,
};


export default (state = templateState, action) => {

  let currentPowerSupply;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
    return state;
  }

  if (action.type !== "CREATE_POWER_SUPPLY" && !action.type.includes("@redux")) {
    if (action.payload.hasOwnProperty("id")) {
      if (state.protocolSection.scene.apparatus.hasOwnProperty("powerSupply")) {
        currentPowerSupply = state.protocolSection.scene.apparatus.powerSupply[findIndex(state.protocolSection.scene.apparatus.powerSupply, { id: action.payload.id })]
      }
    }
  }

  switch (action.type) {
    case 'CREATE_POWER_SUPPLY':
      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props }

      if (protocolSection.scene.apparatus.hasOwnProperty("powerSupply")) {
        protocolSection.scene.apparatus.powerSupply = [...protocolSection.scene.apparatus.powerSupply, newObj]
      } else {
        protocolSection.scene.apparatus.powerSupply = [newObj]
      }

      return {
        ...state, ...{
          protocolSection: protocolSection
        }
      }

    case "SET_POWER_SUPPLY_ANODE_CONNECTED":
      //Payload = {anodeConnected}
      currentPowerSupply.anodeConnected = action.payload.anodeConnected
      currentPowerSupply.cables = {
        ...currentPowerSupply.cables,
        cathode: action.payload.anodeConnected ? 'red' : null,
      }
      return updateState();

    case "SET_POWER_SUPPLY_CATHODE_CONNECTED":
      //Payload = {cathodeConnected}
      currentPowerSupply.cathodeConnected = action.payload.cathodeConnected
      currentPowerSupply.cables = {
        ...currentPowerSupply.cables,
        anode: action.payload.cathodeConnected ? 'black' : null,
      }
      return updateState();


    case TOGGLE_MODAL_OPEN:

      currentPowerSupply.modalOpen = !currentPowerSupply.modalOpen
      return updateState();
 
    case TOGGLE_POWER:
      currentPowerSupply.power = !currentPowerSupply.power
      return updateState();

    case SET_TIMER:
      currentPowerSupply.settings = {
        ...currentPowerSupply.settings,
        timer: action.payload.data,
        hours: action.payload.data.getHours(),
        minutes: action.payload.data.getMinutes(),
        seconds: action.payload.data.getSeconds()
      }
      return updateState();

    case SET_VOLTAGE:
      currentPowerSupply.settings = {
        ...currentPowerSupply.settings,
        voltage: action.payload.data,
      }
      return updateState();

    case SET_CURRENT:
      currentPowerSupply.settings = {
        ...currentPowerSupply.settings,
        current: action.payload.data,
      }
      return updateState();

    case ON_START:
      currentPowerSupply.running = true
      return updateState();

    case ON_STOP:
      currentPowerSupply.running = false
      return updateState();

    case ANIMATION_PLAYBACK_COMPLETE:
      currentPowerSupply.running = false
      currentPowerSupply.completed = true
      currentPowerSupply.settings = {
        ...currentPowerSupply.settings,
        timer: new Date(0, 0, 0),
      }
      return updateState();

    case "UNDO":
      //Payload = {lastState}
      if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('powerSupply')) {
        protocolSection.scene.apparatus.powerSupply = action.payload.lastState.scene.apparatus.powerSupply
        return {
          ...state, ...{
            protocolSection: protocolSection
          }
        }

      } else {
        return state;
      }

    default:
      return state;
  }

  function updateState() {
    protocolSection.scene.apparatus.powerSupply[findIndex(state.powerSupply, { id: action.payload.id })] = currentPowerSupply;
    return { ...state, ...{ protocolSection: protocolSection } };
  }
};
